export default __webpack_public_path__ + "static/media/mobile_Affiliate_program.a4015e96.webp";